import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Button, Label } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { useNavigate, useParams } from "react-router-dom";

const EditCourseDiscount = (props) => {
  const navigate = useNavigate();
  const { id, term_name } = useParams();
  console.log("Params:", id, term_name);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Course Discounts", link: "#" },
    { title: "Edit Course Discount", link: "#" },
  ];
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [termAmount, setTermAmount] = useState(0);
  const [balance, setBalance] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch discount record and get term details
  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        const res = await axios.get(`${backendUrl}get-discount-by-id/${id}`);
        if (res.status === 200) {
          console.log("Fetched Discount Data:", res.data);
          const discountData = res.data.discount;

          // Find the term by term_name
          const term = discountData.discount_details.find(
            (t) => t.term_name === term_name
          );

          if (term) {
            setTermAmount(term.amount + term.balance); // original term amount
            setAmount(term.amount);
            setBalance(term.balance);
            setRemarks(term.remarks || "");
          }
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to load discount details.");
      }
    };

    fetchDiscount();
    props.setBreadcrumbItems("Course Discounts", breadcrumbItems);

  }, [id, term_name, backendUrl]);

  // Update balance dynamically when discount amount changes
  const handleAmountChange = (e) => {
    const val = Number(e.target.value);
    setAmount(val);
    setBalance(termAmount - val);
  };

  // Handle edit submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount) {
      toast.error("Please enter the discount amount.");
      return;
    }

    // ❗ Prevent updating when discount > termAmount
    if (Number(amount) > Number(termAmount)) {
      toast.error(`Discount cannot be greater than Term Amount (${termAmount})`);
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = { amount: Number(amount), remarks };
      const res = await axios.put(
        `${backendUrl}edit-term-discount/${id}/${term_name}`,
        payload
      );

      if (res.status === 200) {
        toast.success(res.data.message);
        setTimeout(() => navigate("/course-discounts-list"), 2000);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <ToastContainer position="top-right" autoClose={4000} transition={Bounce} />
        <Col xl="6" className="mx-auto">
          <Card>
            <CardBody>
              <h4 className="card-title mb-4">Edit Term Discount</h4>
              <AvForm onValidSubmit={handleSubmit}>
                <Row>
                  <Col md="6" className="mb-3">
                    <Label>Term Amount</Label>
                    <div className="border rounded p-2 bg-light">{termAmount}</div>
                  </Col>

                  <Col md="6" className="mb-3">
                    <Label>Balance</Label>
                    <div className="border rounded p-2 bg-light">{balance}</div>
                  </Col>

                  <Col md="6" className="mb-3">
                    <Label>Discount Amount</Label>
                    <AvField
                      type="number"
                      name="amount"
                      value={amount}
                      onKeyDown={(e) => {
                        const invalidKeys = ["-", "+", "e", "E", ".", ","];
                        if (invalidKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        let val = e.target.value;
                        val = val.replace(/\D/g, ""); // digits only
                        setAmount(val);
                        setBalance(termAmount - Number(val));
                      }}
                      validate={{
                        required: { value: true, errorMessage: "Enter discount amount" },
                        pattern: { value: "^[0-9]+$", errorMessage: "Enter a valid number" },
                      }}
                    />


                  </Col>

                  {/* <Col md="12" className="mb-3">
                    <Label>Remarks</Label>
                    <AvField
                      type="textarea"
                      name="remarks"
                      rows="3"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Enter any remarks"

                    />
                  </Col> */}


                  <Col md="6">
  <div className="mb-6">
    <Label htmlFor="refund_reason">
      Remarks <span className="text-danger">*</span>
    </Label>
    <AvField
      name="refund_reason"
      type="textarea"
      className="form-control"
      id="remarks"
      rows="3"
      placeholder="Enter refund reason"
      value={remarks}
      onChange={(e) => setRemarks(e.target.value)}
      // validate={{
      //   required: { value: true, errorMessage: "Refund reason is required" }
      // }}
      style={{
        resize: "none", // Disables resizing
        overflow: "auto", // Shows scrollbar when needed
        minHeight: "41px", // Minimum height
        maxHeight: "41px" // Maximum height before scrolling
      }}
    />
  </div>
</Col>

                  <Col md="12" className="mt-3">
                    <Button color="primary" type="submit" disabled={isSubmitting}>
                      {isSubmitting ? "Updating..." : "Update Discount"}
                    </Button>
                    <Button
                      color="secondary"
                      className="ms-2"
                      onClick={() => navigate("/course-discounts-list")}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(EditCourseDiscount);
